import { render, staticRenderFns } from "./desarrollo.vue?vue&type=template&id=f8ac63bc&scoped=true"
import script from "./desarrollo.vue?vue&type=script&lang=js"
export * from "./desarrollo.vue?vue&type=script&lang=js"
import style0 from "./desarrollo.vue?vue&type=style&index=0&id=f8ac63bc&prod&scoped=true&lang=css"
import style1 from "./desarrollo.vue?vue&type=style&index=1&id=f8ac63bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8ac63bc",
  null
  
)

export default component.exports